import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Office as OfficeType } from '../../law-firm/lawFirm.types';
import { numberWithSpaces } from '../../utils/math';
import { HyperlinkRestrictedBaseModal } from '../../components/HyperlinkRestrictedBaseModal';
import {
  EntityListItem,
  EntityListIcon,
  EntityListGroup,
  EntityListSubtitleBlock,
} from './components/EntityListComponents';
import styles from './office_list.module.scss';

type Props = {
  offices: Array<OfficeType>;
  source: string;
};

export const OfficeList: FC<Props> = ({ source, offices }) => {
  return (
    <>
      {offices.map(office => (
        <EntityListItem key={office.nic}>
          <EntityListIcon
            src="/img/icons/entities/law-firm.svg"
            alt="law-firm-icon"
          />
          <EntityListGroup>
            <HyperlinkRestrictedBaseModal
              className={styles.title}
              url={office.route}
              source={source}
            >
              {office.ville}
            </HyperlinkRestrictedBaseModal>
            <br />
            <EntityListSubtitleBlock>
              {numberWithSpaces(Number(office.nbLawyers))}{' '}
              <FormattedMessage id="entity/entity-lists/OfficeList.tsx/1" />
              {Number(office.nbLawyers) > 1 ? 's' : ''}
            </EntityListSubtitleBlock>
          </EntityListGroup>
        </EntityListItem>
      ))}
    </>
  );
};
